var _filter, _filter2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 3000 1600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 1200,
    width: 1544,
    x: 1682,
    y: 200
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 100
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 900,
    width: 982,
    x: 0,
    y: 23
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 100
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2550,
    cy: 1150,
    fill: "#f5a142",
    r: 330
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 330,
    cy: 430,
    fill: "#4185f2",
    rx: 390,
    ry: 260
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalls);
export default __webpack_public_path__ + "static/media/balls.51c9678b6411b353a24e50e40286a378.svg";
export { ForwardRef as ReactComponent };